<template>
  <div>

    <div style="display: flex;">

      <div id="left-menu" class="content-son-box" style="width: 190px;margin-right: 10px;height: 100%;position: relative;top: 0px;">
        <div @click="back()"
          style="height: 30px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
              d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
              fill="#EA3928" />
          </svg>
          <span style="margin-left: 10px;">返回</span>
        </div>
        <div style="padding: 10px 0 10px 20px;font-size: 17px;">
          <!--            <div style="margin-bottom: 10px;">目录</div>-->
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-0">主要指标</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-0')">主要指标</div>
            </div>
          </div>
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-1">利润表</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-1')">利润表</div>
            </div>
          </div>
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-2">资产负债表</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-2')">资产负债表</div>
            </div>
          </div>
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-3">现金流量表</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-3')">现金流量表</div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-right" style="width: 1000px;">


        <div class="content-son-box" id="box-0">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">主要指标</span>
          </div>
          <div class="select-bar">
            <div class="select-box">
              <template v-for="(item, index) in selectTimeList">
                <div class="select-item-selected" v-if="selectedIndex1 == index" :key="'s' + index">
                  {{ item }}
                </div>
                <div class="select-item" v-else :key="index" @click="changeSelect(1, index)">
                  {{ item }}
                </div>
              </template>
            </div>
          </div>
          <div>
            <el-table :data="tableData1" border style="width: 100%" :header-cell-style="tableHeaderStyle"
              :row-class-name="tableRowClassName">
              <el-table-column fixed prop="subjectName" label="报告期" width="200"></el-table-column>
              <el-table-column v-for="(item, index) in tableHeadData1" :key="index" :prop="'data' + index" :label="item"
                width="157"></el-table-column>
            </el-table>
          </div>
        </div>

        <div class="content-son-box" id="box-1">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">利润表</span>
          </div>
          <div class="select-bar">
            <div class="select-box">
              <template v-for="(item, index) in selectTimeList">
                <div class="select-item-selected" v-if="selectedIndex2 == index" :key="'s' + index">
                  {{ item }}
                </div>
                <div class="select-item" v-else :key="index" @click="changeSelect(2, index)">
                  {{ item }}
                </div>
              </template>
            </div>
          </div>
          <div>
            <el-table :data="tableData2" border style="width: 100%" :header-cell-style="tableHeaderStyle"
              :row-class-name="tableRowClassName">
              <el-table-column fixed prop="subjectName" label="报告期" width="200"></el-table-column>
              <el-table-column v-for="(item, index) in tableHeadData2" :key="index" :prop="'data' + index" :label="item"
                width="157"></el-table-column>
            </el-table>
          </div>
        </div>

        <div class="content-son-box" id="box-2">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">资产负债表</span>
          </div>
          <div class="select-bar">
            <div class="select-box">
              <template v-for="(item, index) in selectTimeList">
                <div class="select-item-selected" v-if="selectedIndex3 == index" :key="'s' + index">
                  {{ item }}
                </div>
                <div class="select-item" v-else :key="index" @click="changeSelect(3, index)">
                  {{ item }}
                </div>
              </template>
            </div>
          </div>
          <div>
            <el-table :data="tableData3" border style="width: 100%" :header-cell-style="tableHeaderStyle"
              :row-class-name="tableRowClassName">
              <el-table-column fixed prop="subjectName" label="报告期" width="200"></el-table-column>
              <el-table-column v-for="(item, index) in tableHeadData3" :key="index" :prop="'data' + index" :label="item"
                width="157"></el-table-column>
            </el-table>
          </div>
        </div>

        <div class="content-son-box" id="box-3">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">现金流量表</span>
          </div>
          <div class="select-bar">
            <div class="select-box">
              <template v-for="(item, index) in selectTimeList">
                <div class="select-item-selected" v-if="selectedIndex4 == index" :key="'s' + index">
                  {{ item }}
                </div>
                <div class="select-item" v-else :key="index" @click="changeSelect(4, index)">
                  {{ item }}
                </div>
              </template>
            </div>
          </div>
          <div>
            <el-table :data="tableData4" border style="width: 100%" :header-cell-style="tableHeaderStyle"
              :row-class-name="tableRowClassName">
              <el-table-column fixed prop="subjectName" label="报告期" width="200"></el-table-column>
              <el-table-column v-for="(item, index) in tableHeadData4" :key="index" :prop="'data' + index" :label="item"
                width="157"></el-table-column>
            </el-table>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestCompany2 } from '../../../../static/js/util';

export default {
  data() {
    return {
      comCode: '',
      name: '',

      dataList1: null,
      dataList2: null,
      dataList3: null,
      dataList4: null,

      tableHeadData1: null,
      tableHeadData2: null,
      tableHeadData3: null,
      tableHeadData4: null,
      tableData1: null,
      tableData2: null,
      tableData3: null,
      tableData4: null,

      selectTimeList: ['最新', '一季报', '中报', '三季报', '年报'],
      selectedIndex1: 0,
      selectedIndex2: 0,
      selectedIndex3: 0,
      selectedIndex4: 0,
    };
  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.name = this.$route.query.comName;

    window.parent.onscroll = () => {
      var scrollHeight = window.parent.scrollY;
      if (scrollHeight > 100) {
        $('#left-menu').css({ top: scrollHeight - 100 + 'px' });
      } else {
        $('#left-menu').css({ top: '0px' });
      }
    }

    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'companyResearch');
    },
    moveToId(idStr) {
      document.querySelector(idStr).scrollIntoView({
        behavior: "smooth"
     });
    },
    tableHeaderStyle() {
      var style = {
        background: '#E4E7ED',
        color: '#606266',
        border: '1px solid #DCDFE6'
      }
      return style;
    },
    tableRowClassName({ row, rowIndex }) {
      return 'row-type-' + row.subjectType;
    },
    getData() {
      this.getMainIndicators();
      this.getIncomStatement();
      this.getBalanceSheet();
      this.getCashFlowStatement();
    },
    getMainIndicators() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      let url = '/report/reportFinance/' + this.comCode + '/0'
      sendRequestCompany2(url, 'get', null, response => {
        loading.close();
        if (response.data.code == 0) {
          this.dataList1 = JSON.parse(response.data.data.resultJson);
          this.changeSelect(1, 0);
        } else {
          this.$message.error(response.data.msg);
        }

      }, error => {
        loading.close();
        console.log(error);
      })
    },
    getIncomStatement() {
      let url = '/report/reportFinance/' + this.comCode + '/1'
      sendRequestCompany2(url, 'get', null, response => {
        if (response.data.code == 0) {
          this.dataList2 = JSON.parse(response.data.data.resultJson);
          this.changeSelect(2, 0);
        } else {
          this.$message.error(response.data.msg);
        }
      }, error => {
        console.log(error);
      })
    },
    getBalanceSheet() {
      let url = '/report/reportFinance/' + this.comCode + '/2'
      sendRequestCompany2(url, 'get', null, response => {
        if (response.data.code == 0) {
          this.dataList3 = JSON.parse(response.data.data.resultJson);
          this.changeSelect(3, 0);
        } else {
          this.$message.error(response.data.msg);
        }
      }, error => {
        console.log(error);
      })
    },
    getCashFlowStatement() {
      let url = '/report/reportFinance/' + this.comCode + '/3'
      sendRequestCompany2(url, 'get', null, response => {
        if (response.data.code == 0) {
          this.dataList4 = JSON.parse(response.data.data.resultJson);
          this.changeSelect(4, 0);
        } else {
          this.$message.error(response.data.msg);
        }
      }, error => {
        console.log(error);
      })
    },
    changeSelect(sign, index) {
      if (sign == 1) {
        this.selectedIndex1 = index;
        var data = this.dataToTable(index, this.dataList1);
        if (data != null) {
          this.tableHeadData1 = data.tableHeadData;
          this.tableData1 = data.tableData;
        }
      } else if (sign == 2) {
        this.selectedIndex2 = index;
        var data = this.dataToTable(index, this.dataList2);
        if (data != null) {
          this.tableHeadData2 = data.tableHeadData;
          this.tableData2 = data.tableData;
        }
      } else if (sign == 3) {
        this.selectedIndex3 = index;
        var data = this.dataToTable(index, this.dataList3);
        if (data != null) {
          this.tableHeadData3 = data.tableHeadData;
          this.tableData3 = data.tableData;
        }
      } else if (sign == 4) {
        this.selectedIndex4 = index;
        var data = this.dataToTable(index, this.dataList4);
        if (data != null) {
          this.tableHeadData4 = data.tableHeadData;
          this.tableData4 = data.tableData;
        }
      }
    },
    dataToTable(index, dataList) {
      if (dataList == null || dataList == undefined || dataList.financeReportInfos == undefined) {
        return null;
      }

      var tableHeadData = [];
      var tableData = [];

      if (index == 0) {

        //第一列
        for (var i = 0; i < dataList.financeReportSubjectNames.length; i++) {
          var row = {
            "subjectName": dataList.financeReportSubjectNames[i].subjectName,
            "subjectType": dataList.financeReportSubjectNames[i].subjectType
          }
          tableData.push(row);
        }

        //后续列
        for (var i = 0; i < dataList.financeReportInfos.length; i++) {
          var colTemp = dataList.financeReportInfos[i];
          tableHeadData.push(colTemp.reportDate);

          // for (var j = 0; j < tableData.length; j++) {
          //   tableData[j]['data' + i] = colTemp.financeReportInfoEleList[j].subjectValStr;
          // }
          for (var j = 0; j < colTemp.financeReportInfoEleList.length; j++) {
            tableData[j]['data' + i] = colTemp.financeReportInfoEleList[j].subjectValStr;
          }
        }

      } else if (index != 0) {

        //第一列
        for (var i = 0; i < dataList.financeReportSubjectNames.length; i++) {
          var row = {
            "subjectName": dataList.financeReportSubjectNames[i].subjectName,
            "subjectType": dataList.financeReportSubjectNames[i].subjectType
          }
          tableData.push(row);
        }

        var dateType;
        switch (index) {
          case 1:
            dateType = '1';
            break;
          case 2:
            dateType = '2';
            break;
          case 3:
            dateType = '3';
            break;
          case 4:
            dateType = '0';
            break;
        }

        //后续列
        var sign = 0;
        for (var i = 0; i < dataList.financeReportInfos.length; i++) {
          var colTemp = dataList.financeReportInfos[i];
          if (colTemp.dateType != dateType) {
            continue;
          }

          tableHeadData.push(colTemp.reportDate);

          // for (var j = 0; j < tableData.length; j++) {
          //   tableData[j]['data' + sign] = colTemp.financeReportInfoEleList[j].subjectValStr;
          // }
          for (var j = 0; j < colTemp.financeReportInfoEleList.length; j++) {
            tableData[j]['data' + sign] = colTemp.financeReportInfoEleList[j].subjectValStr;
          }

          sign++;
        }
      }

      return {
        tableHeadData: tableHeadData,
        tableData: tableData
      }
    }

  }
};
</script>
    
<style scoped>
.select-bar {
  padding: 5px;
}

.select-box {
  border: 1px solid #999;
  border-radius: 5px;
  display: flex;
}

.select-item {
  color: #333;
  flex: 1;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}

.select-item-selected {
  color: #fff;
  background-color: #DA0519;
  border-radius: 4px;
  flex: 1;
  text-align: center;
  padding: 5px 0;
}

.content-right /deep/ .el-table .row-type-1 {
  background-color: #d9d9d9;
  height: 30px;
  font-size: 18px;
  color: #3a3a3a;
}

.content-right /deep/ .el-table .row-type-2 {
  background-color: #d9d9d9;
  height: 30px;
  font-size: 17px;
  color: #3a3a3a;
}

.content-right /deep/ .el-table .row-type-3 {
  background-color: #ffffff;
  height: 30px;
  font-size: 16px;
  color: #3a3a3a;
}

.content-right /deep/ .el-table .row-type-3 td:first-child .cell {
  padding-left: 30px !important;
}

.content-right /deep/ .el-table .row-type-4 {
  background-color: #ffffff;
  height: 30px;
  font-size: 16px;
  color: #3a3a3a;
}

.content-right /deep/ .el-table .row-type-4 td:first-child .cell {
  padding-left: 40px !important;
}

.content-son-box {
  margin-top: 30px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
</style>